import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight, Clock3 } from 'lucide-react';
import Card from '../ui/Card';
import Button from '../ui/Button';
import { servicePackages } from '../../data/services';

const ServicePackages = () => {
  return (
    <section className="section section-black">
      <div className="container">
        <div className="section-header">
          <div className="eyebrow">Our Services</div>
          <h2>Choose Your Perfect Package</h2>
          <p>
            From essential cleaning to complete detailing, we have a package to suit
            every need and budget.
          </p>
        </div>

        <div className="grid grid-4">
          {servicePackages.map((pkg) => (
            <Card
              key={pkg.id}
              hover
              className={`service-card ${pkg.popular ? 'popular' : ''}`}
            >
              {pkg.popular && (
                <div className="service-card-badge">Most Popular</div>
              )}

              <div className="service-card-header">
                <h3 className="service-card-name">{pkg.name}</h3>
                <div className="service-card-tagline">{pkg.tagline}</div>
                <div className="service-card-price">
                  {pkg.price}
                  <span>Starting from</span>
                </div>
                <div className="service-card-duration">
                  <Clock3 size={14} />
                  {pkg.duration}
                </div>
              </div>

              <ul className="service-card-features">
                {pkg.features.slice(0, 5).map((feature, idx) => (
                  <li key={idx}>
                    <Check size={16} />
                    <span>{feature}</span>
                  </li>
                ))}
                {pkg.features.length > 5 && (
                  <li style={{ color: 'var(--gold)', fontWeight: 600 }}>
                    +{pkg.features.length - 5} more features
                  </li>
                )}
              </ul>

              <Link to="/services" state={{ selectedPackage: pkg.id }}>
                <Button
                  variant={pkg.popular ? 'primary' : 'outline'}
                  size="sm"
                  className="w-full"
                  icon={ArrowRight}
                >
                  View Details
                </Button>
              </Link>
            </Card>
          ))}
        </div>

        <div className="text-center" style={{ marginTop: '3rem' }}>
          <Link to="/services">
            <Button variant="secondary" size="lg">
              View All Services & Pricing
              <ArrowRight size={18} />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicePackages;